import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { combineLatest, Subscription} from 'rxjs';
import { MktEnvironmentService } from 'src/app/core/services/mkt-environment.service';
import { MktContentStorageService } from 'src/app/core/services/mkt-content-storage.service';
import { MktCommonModule } from 'src/app/common/mkt-common.module';

@Component({
  selector: 'app-rewards-section',
  templateUrl: './rewards-section.component.html',
  styleUrls: ['./rewards-section.component.scss'],
  imports:[MktCommonModule],
  standalone: true
})
export class RewardsSectionComponent implements OnInit, OnDestroy {
  rewardsContent: any = null;
  leftColData: any;
  rightColData: any;
  isPointTemplate = true;
  imageBasePath: String = '';
  pricingDetails; any;
  pid: number;
  greenLighteningContent: String = '';

  routeSub: Subscription = new Subscription();
  constructor(private _mktContentStorageService: MktContentStorageService,
    private mktEnvironmentService: MktEnvironmentService,
    private route: ActivatedRoute) {
    this.imageBasePath = this.mktEnvironmentService.getEnvironmentVar('cardsmkrHostName');
  }

  ngOnInit(): void {
    this.getRewardContent();
  }

  ngOnDestroy() {
    this.routeSub.unsubscribe();
  }


  private getRewardContent() {
    this.routeSub = combineLatest([
      this.route.params
    ]).subscribe(params => {
      const cardName = params[0]['cardName'].replace(/\./g, '');
      // Try to get card pricing details
      const mainPdpContentObject = this._mktContentStorageService.get('Product_Detail_Pages', 'copy', cardName, undefined);
      if (!mainPdpContentObject) {
        return;
      }

      this.rewardsContent = JSON.parse(mainPdpContentObject['rewardSection']);

      if (!this.rewardsContent || !this.rewardsContent.rewardActive) { return; }
      this.pid = JSON.parse(mainPdpContentObject.TEXT).pid;
      this.greenLighteningContent = this.rewardsContent.greenLighteningContent;
      this.leftColData = this.rewardsContent.leftColData;
      this.rightColData = this.rewardsContent.rightColData;
      // check for template type
      this.isPointTemplate = this.rewardsContent.leftColData?.type === 'pointsContent';
    });
  }

  getTemplateClass() {
    let templateClass = 'style1';

    if (this.leftColData && this.leftColData.style) {
      templateClass = this.leftColData.style;
    }

    return templateClass;
  }
}
